import React, {Fragment} from 'react';

export default function NotFound(props) {
    return <Fragment>
        <div className="error">Oops! That page doesn't seem to exist!</div>
    </Fragment>
}